import { Component } from '@angular/core';

@Component({
  selector: 'app-mode-demploi',
  templateUrl: './mode-demploi.page.html',
  styleUrl: './mode-demploi.page.scss',
})
export class ModeDemploiPage {}